// Generated by CoffeeScript 2.7.0
var GenerateMorePopover;

export default GenerateMorePopover = {
  beforeAction: function() {
    this._initMorePopover();
    // 监听body宽度变化，调用_initMorePopover函数决定popover的显隐
    return window.addEventListener('resize', this._initMorePopover);
  },
  beforeRender: function() {
    // 离开页面时销毁window上的事件监听
    return window.removeEventListener('resize', this._initMorePopover);
  },
  _initMorePopover: function() {
    var body_width, child, children_html, i, j, list_children, nav_menu, ref;
    // 获取页面渲染的所有nav-item, body的宽度
    // 如果页面宽度小于1120并且nav-item的个数大于5个
    // 将超过的元素添加到more-toggle-popover里并隐藏nav-menu中的nav-item，然后实例化一个popover
    // 否则展示全部nav-item，隐藏more-toggle-popover
    list_children = DomMaster.findAll('.nav-menu .nav-item');
    nav_menu = DomMaster.find('.nav-menu').node;
    body_width = DomMaster.find('body').node.offsetWidth;
    if (list_children.length > 5 && body_width < 1120) {
      children_html = '';
      for (i = j = 6, ref = list_children.length; (6 <= ref ? j < ref : j > ref); i = 6 <= ref ? ++j : --j) {
        child = list_children[i];
        children_html += `<a class="menu-item" href="${child.node.href}">
  <div class="entrance-icon">${child.node.querySelector(".entrance-icon").innerHTML}</div>
  <div class="mt-2 darken-text">${child.node.innerText}</div>
</a>`;
      }
      nav_menu.classList.add('with-popover');
      DomMaster.find('.more-toggle-popover .menu-list').node.innerHTML = children_html;
      return new Skylark.Elements.Popover(DomMaster.find('.more-toggle-popover'), {
        size: 'larger',
        type: 'prompt'
      });
    } else {
      return nav_menu.classList.remove('with-popover');
    }
  }
};
